import React from 'react';

export default function CookiePolicy() {
  return (
    <div className="mx-auto max-w-4xl px-6 text-gray-800 dark:text-gray-200">
      {/*<h1 className="text-3xl font-bold mb-6">Cookie Policy</h1>*/}
      <div className="bg-white px-6 py-16 text-gray-900 dark:bg-gray-900 dark:text-white sm:py-24 lg:px-8">
        <div className="mx-auto max-w-4xl space-y-12">
          <header>
            <h1 className="mb-4 text-4xl font-bold">Cookie Policy</h1>
            <p>
              La presente Cookie Policy descrive le modalità di utilizzo dei cookie e di altre
              tecnologie di tracciamento da parte del sito <strong>www.nccbrodriver.it</strong>.
            </p>
            <p className="mt-2">
              Titolare del trattamento: <strong>NCC BroDriver</strong>
            </p>
          </header>

          <section>
            <h2 className="mb-2 text-2xl font-semibold">Cosa sono i cookie</h2>
            <p>
              I cookie sono piccoli file di testo che i siti inviano al browser per migliorare
              l’esperienza di navigazione. Possono essere usati per riconoscere l’utente, analizzare
              il traffico o ricordare preferenze personalizzate.
            </p>
            <p className="mt-2">
              La disattivazione dei cookie può compromettere la piena funzionalità del sito.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-2xl font-semibold">Gestione dei cookie</h2>
            <p>
              Puoi gestire le preferenze sui cookie direttamente dal tuo browser. Consulta la
              sezione &quot;Aiuto&quot; del tuo browser per configurare accettazione o blocco dei
              cookie.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-2xl font-semibold">Tecnologie di tracciamento aggiuntive</h2>
            <p>
              Oltre ai cookie, possiamo utilizzare tecnologie come i <strong>web beacons</strong>{' '}
              per analizzare l’interesse degli utenti verso contenuti specifici o monitorare
              interazioni con email promozionali.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-2xl font-semibold">Tipologie di cookie</h2>

            <div className="mt-4 space-y-4">
              <div>
                <h3 className="text-lg font-semibold">🍪 Cookie tecnici</h3>
                <p>
                  Utilizzati solo per il funzionamento del sito. Non richiedono il consenso
                  dell’utente.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold">🎯 Cookie di profilazione</h3>
                <p>
                  Utilizzati per creare profili utente e mostrare pubblicità personalizzata.
                  Richiedono consenso esplicito.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="mb-2 text-2xl font-semibold">Cookie di prima e terza parte</h2>
            <p>I cookie possono essere:</p>
            <ul className="mt-2 list-inside list-disc space-y-1">
              <li>
                <strong>Di prima parte</strong>: gestiti direttamente da NCC BroDriver
              </li>
              <li>
                <strong>Di terza parte</strong>: gestiti da soggetti esterni, es. Google, Facebook
              </li>
            </ul>
            <p className="mt-2">
              Il consenso per i cookie di profilazione viene raccolto tramite banner al primo
              accesso.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-2xl font-semibold">Cookie di terze parti utilizzati</h2>

            <p className="mb-4">
              Di seguito un elenco dei principali servizi esterni che possono salvare cookie:
            </p>

            <ul className="space-y-4 text-sm text-gray-700 dark:text-gray-300">
              {[
                ['MailUp (MailUp S.p.A.)', 'Invio newsletter e SMS marketing'],
                ['Google+ Widget', 'Interazione social'],
                ['LinkedIn Widget', 'Interazione social'],
                ['Facebook Like & Remarketing', 'Interazione e pubblicità personalizzata'],
                ['Twitter Widget', 'Interazione social'],
                ['Pinterest Widget', 'Interazione social'],
                [
                  'Google Ads / Analytics',
                  'Remarketing, tracciamento conversioni, analisi traffico',
                ],
                ['Facebook Custom Audience', 'Pubblicità personalizzata'],
              ].map(([name, purpose]) => (
                <li key={name}>
                  <strong>{name}</strong> — {purpose}
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-2xl font-semibold">Impatto della disattivazione dei cookie</h2>
            <p>
              Il blocco dei cookie tecnici può limitare funzionalità importanti come
              l’autenticazione, la personalizzazione del contenuto e la corretta visualizzazione del
              sito.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-2xl font-semibold">Collegamenti esterni</h2>
            <p>
              Il sito può contenere link a siti esterni. NCC BroDriver non è responsabile per l’uso
              di cookie su siti di terze parti.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-2xl font-semibold">Contatti</h2>
            <p>Per domande o richieste riguardo questa Cookie Policy, contattaci a:</p>
            <p className="mt-2 font-medium">📧 info@nccbrodriver.it</p>
          </section>

          <footer className="border-t border-gray-200 pt-10 text-sm dark:border-gray-700">
            <p>Ultimo aggiornamento: 18 giugno 2018</p>
          </footer>
        </div>
      </div>
    </div>
  );
}
